import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Draggable from "react-draggable";

import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

import MDButton from "components/MDButton";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title-override-historico"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function fmtDataHora(v) {
  if (!v) return "";

  const d = new Date(v);

  if (Number.isNaN(d.getTime())) {
    return String(v);
  }

  return d.toLocaleString("pt-PT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function valorApresentacao(v) {
  if (v === null || v === undefined || v === "") {
    return "—";
  }

  return String(v);
}

export default function DialogVendasTransportesOverrideHistorico({
  open,
  loading,
  rows,
  reftransporte,
  datafim,
  onClose,
}) {
  const columns = useMemo(
    () => [
      {
        Header: "Data / Hora",
        accessor: "alterado_em",
        width: 155,
        minWidth: 145,
        maxWidth: 190,
        sortType: "textPt",
        Cell: ({ value }) => <span style={{ whiteSpace: "nowrap" }}>{fmtDataHora(value)}</span>,
      },
      {
        Header: "Utilizador",
        accessor: "utilizador",
        width: 210,
        minWidth: 150,
        maxWidth: 340,
        sortType: "textPt",
      },
      {
        Header: "Campo",
        accessor: "campo_descricao",
        width: 210,
        minWidth: 170,
        maxWidth: 300,
        sortType: "textPt",
        Cell: ({ value }) => <span style={{ fontWeight: 600 }}>{valorApresentacao(value)}</span>,
      },
      {
        Header: "Estado anterior",
        accessor: "valor_anterior",
        width: 220,
        minWidth: 130,
        maxWidth: 500,
        sortType: "textPt",
        Cell: ({ value, row }) => {
          const isObservacoes = row?.original?.campo === "observacoes";

          return (
            <div
              style={{
                whiteSpace: isObservacoes ? "pre-wrap" : "nowrap",
                overflowWrap: "anywhere",
              }}
            >
              {valorApresentacao(value)}
            </div>
          );
        },
      },
      {
        Header: "Novo estado",
        accessor: "valor_novo",
        width: 220,
        minWidth: 130,
        maxWidth: 500,
        sortType: "textPt",
        Cell: ({ value, row }) => {
          const isObservacoes = row?.original?.campo === "observacoes";

          return (
            <div
              style={{
                fontWeight: 600,
                whiteSpace: isObservacoes ? "pre-wrap" : "nowrap",
                overflowWrap: "anywhere",
              }}
            >
              {valorApresentacao(value)}
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title-override-historico"
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          width: {
            xs: "calc(100% - 16px)",
            sm: "calc(100% - 32px)",
          },
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        id="draggable-dialog-title-override-historico"
        sx={{
          cursor: "move",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <span>
          Histórico de overrides — {datafim} — Transporte {reftransporte}
        </span>

        <IconButton size="small" onClick={onClose} title="Fechar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          px: {
            xs: 1,
            sm: 2,
          },
        }}
      >
        <ProjectTable
          tableKey="vendasTransportesOverrideHistorico"
          version="v1"
          columns={columns}
          data={rows}
          loading={loading}
          emptyMessage="Sem alterações manuais registadas."
          minWidth={980}
          maxHeight="58vh"
          defaultSortBy={[
            {
              id: "alterado_em",
              desc: true,
            },
          ]}
          showKeepFilters
        />
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

DialogVendasTransportesOverrideHistorico.defaultProps = {
  open: false,
  loading: false,
  rows: [],
  reftransporte: "",
  datafim: "",
};

DialogVendasTransportesOverrideHistorico.propTypes = {
  open: PropTypes.bool,
  loading: PropTypes.bool,
  rows: PropTypes.array,
  reftransporte: PropTypes.string,
  datafim: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};
